import * as React from "react";

export const IconFormatListBulleted = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_40500_29755)">
        <path
          d="M3.33334 8.75C2.64168 8.75 2.08334 9.30833 2.08334 10C2.08334 10.6917 2.64168 11.25 3.33334 11.25C4.02501 11.25 4.58334 10.6917 4.58334 10C4.58334 9.30833 4.02501 8.75 3.33334 8.75ZM3.33334 3.75C2.64168 3.75 2.08334 4.30833 2.08334 5C2.08334 5.69167 2.64168 6.25 3.33334 6.25C4.02501 6.25 4.58334 5.69167 4.58334 5C4.58334 4.30833 4.02501 3.75 3.33334 3.75ZM3.33334 13.75C2.64168 13.75 2.08334 14.3167 2.08334 15C2.08334 15.6833 2.65001 16.25 3.33334 16.25C4.01668 16.25 4.58334 15.6833 4.58334 15C4.58334 14.3167 4.02501 13.75 3.33334 13.75ZM5.83334 15.8333L17.5 15.8333V14.1667L5.83334 14.1667V15.8333ZM5.83334 10.8333L17.5 10.8333V9.16667L5.83334 9.16667L5.83334 10.8333ZM5.83334 4.16667V5.83333L17.5 5.83333V4.16667L5.83334 4.16667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_40500_29755">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
